<template>
  <el-dialog title="生成二维码" :visible.sync="formVisible" width="500px" v-if="formVisible" :close-on-click-modal="false">
    <div v-if="qrCodeImg" class="img-box">
      <el-image style="width: 200px; height: 200px" :src="qrCodeImg" :preview-src-list="[qrCodeImg]"></el-image>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleDownload" v-if="qrCodeImg">下载二维码</el-button>
      <!-- <el-button type="primary" @click="handleQrcode" v-else>生成二维码</el-button> -->
    </div>
    <div class="qrcode" ref="qrCodeUrl" id="qrcode" v-show="false"></div>

  </el-dialog>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import QRCode from 'qrcodejs2';
export default {
  data() {
    return {
      formVisible: false,
      qrCodeImg: '',
      rowItem: null
    }
  },
  created() {

  },
  methods: {
    handleQRCode(row) {
      sysGoodsApi.getSysGoodsQRCode({goodsId: row.id}).then(res => {
        this.qrCodeImg = 'data:image/jpeg;base64,' + res.data
        this.formVisible = true;
      })
    },
    // handleQrcode() {
    //   let qrcode = new QRCode(this.$refs.qrCodeUrl, {
    //     text: `goodId=${this.rowItem.id}`, // 需要转换为二维码的内容
    //     width: 200,
    //     height: 200,
    //     colorDark: "#000000",
    //     colorLight: "#ffffff",
    //     correctLevel: QRCode.CorrectLevel.H,
    //   });
    //   let myCanvas = document.getElementById("qrcode").getElementsByTagName("canvas");
    //   let url = myCanvas[0].toDataURL("image/png");
    //   this.qrCodeImg = url

    // },
    handleDownload() {
      let { qrCodeImg } = this;
      if (!qrCodeImg) return
      let a = document.createElement("a");
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.href = this.qrCodeImg;
      a.download = "二维码.png"; // 图片名称
      a.dispatchEvent(event); // 触发a的单击事件
      this.$message({ message: "下载成功", type: "success" });
    },
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  text-align: center;
}
</style>
